export const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_17031_3611)">
      <path
        d="M5.37667 14.0585L13.9873 13.9873M13.9873 13.9873L14.0584 5.37675M13.9873 13.9873L4.34087 4.34095"
        stroke="#BEC4D5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17031_3611">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
